import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Price.scss';

const PriceH = ({priceData, color = ''}) => {
	if (!priceData) {
		return null;
	}

	return (
	  <div
		className={`${styles.container} ${styles.containerCenteredText} ${styles.sizeBodyText} ${color ? styles[color] : ''}`}>
		  <div className={styles.prices}>
			  {priceData.price} {priceData.curr}
		  </div>
	  </div>
	);
}

PriceH.propTypes = {
	priceData: PropTypes.object.isRequired,
	color: PropTypes.string
};

export default PriceH;
